import Counter from "@/components/Counter";
import { money } from "@/lib/format";

export default function ShirtOrder({ sizes, price, value, onChange }) {
  return (
    <div className="space-y-3">
      <p className="text-lg">Order shirts for your household — {money(price)} each.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {sizes.map((s) => (
          <div key={s} className="flex items-center justify-between gap-3 rounded-xl border-2 border-[#E6DBCF] bg-white px-4 py-2">
            <span className="text-lg font-semibold">{s}</span>
            <Counter testId={`shirt-${s.toLowerCase().replace(/\s+/g, "-")}`} value={value[s]} onChange={(v) => onChange({ ...value, [s]: v })} />
          </div>
        ))}
      </div>
    </div>
  );
}
